export const Types = {
    SAVE_LIST_BONUS: 'SAVE_LIST_BONUS',
    SAVE_LIST_NOTIFY: 'SAVE_LIST_NOTIFY',
}
  